import React from 'react'
// import CustomComponent from './cascader'
import { Form, Radio, Table, Select } from 'antd'
import { cooperationInfo, natureInfo, columns } from './config'
import API from '../../../../../server/index'

const initialValues = {
  cooperation: '1',
  nature: '1',
}
const basicInfoData = [...cooperationInfo['1'], ...natureInfo['1']]

export default function Information() {
  const [form] = Form.useForm()
  const [basicInfo, setBasicInfo] = React.useState(basicInfoData)
  const [moreInfo, setMoreInfo] = React.useState([])
  const [selectDataSource, setSelectDataSource] = React.useState<any>([])

  const onFormLayoutChange = () => {
    const cooperationVal: any = form.getFieldValue('cooperation')
    const natureVal = form.getFieldValue('nature')
    const data1: any = cooperationInfo[cooperationVal]
    const data2: any = natureInfo[natureVal]

    setBasicInfo([...data1, ...data2])
  }

  const getGoodsInfo = async (params: any) => {
    let arr: any = []
    params.forEach((item: any) => {
      const { categoryNoPath, categoryNo, level } = item
      arr.push({ categoryNoPath, categoryNo, level })
    })
    const res: any = await API.CategoryNo60874({
      mainCategoryPathList: arr,
    })

    if (res) {
      const list = res.list || []
      let data: any = []
      list.forEach((item: any) => {
        const { qualificationName, qualificationDesc } = item
        if (qualificationName) {
          data.push({
            name: qualificationName,
            desc: qualificationDesc || '-',
          })
        }
      })

      setMoreInfo(data)
    }
  }

  const getSelectDataSource = async () => {
    const res: any = await API.NewSupplierCategoryCategoryNo36890({
      categoryNo: '0',
    })
    let array: any[] = []
    if (Array.isArray(res?.list)) {
      array =
        res.list.map((item: any) => {
          const { categoryNo, categoryName } = item
          return {
            ...item,
            value: categoryNo,
            label: categoryName,
          }
        }) ?? []

      setSelectDataSource(array)
    }
  }

  const handleChange = (value: any) => {
    const data = selectDataSource.find((item: any) => item.categoryNo === value);
    getGoodsInfo([data])
  }

  React.useEffect(() => {
    getSelectDataSource()
  }, [])

  return (
    <div className="pc-information-wrapper">
      <Form
        form={form}
        name="basic"
        initialValues={initialValues}
        layout="horizontal"
        onValuesChange={onFormLayoutChange}
      >
        <Form.Item label="合作方式" name="cooperation">
          <Radio.Group>
            <Radio value="1">直播推广</Radio>
            <Radio value="2">供应商</Radio>
            <Radio value="3">短视频推广</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="公司性质" name="nature">
          <Radio.Group>
            <Radio value="1">生产厂商</Radio>
            <Radio value="2">品牌商</Radio>
            <Radio value="3">经销商</Radio>
            <Radio value="4">代理商</Radio>
            <Radio value="5">其他</Radio>
          </Radio.Group>
        </Form.Item>
        {selectDataSource && selectDataSource.length > 0 && (
          <Form.Item label="品牌类目" name="category">
            <Select
              style={{
                width: 260,
              }}
              placeholder='请选择品牌类目'
              options={selectDataSource}
              onChange={handleChange}
            />
          </Form.Item>
        )}
      </Form>
      <div className="title">所需材料清单</div>
      <div className="sub-title">基础资质材料</div>
      <Table
        className="basic-table"
        dataSource={basicInfo}
        bordered
        columns={columns}
        pagination={false}
      />
      {moreInfo && moreInfo.length > 0 && (
        <>
          <div className="sub-title">商品资质材料</div>
          <Table
            className="basic-table"
            dataSource={moreInfo}
            bordered
            columns={columns}
            pagination={false}
          />
        </>
      )}
    </div>
  )
}
